var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.33333C0 0.596952 0.575634 0 1.28571 0H16.7143C17.4244 0 18 0.596953 18 1.33333V3.99999C18 4.73637 17.4244 5.33332 16.7143 5.33332H16.6585L15.5854 17.5747C15.465 18.9483 14.3545 20 13.0245 20H4.97547C3.64552 20 2.53501 18.9483 2.4146 17.5747L1.34149 5.33332H1.28571C0.575634 5.33332 0 4.73637 0 3.99999V1.33333ZM16.7143 1.33333H1.28571V3.99999H16.7143V1.33333ZM2.6325 5.33333L3.69503 17.454C3.75524 18.1408 4.31049 18.6666 4.97547 18.6666H13.0245C13.6895 18.6666 14.2447 18.1408 14.3049 17.454L15.3675 5.33333H2.6325ZM6.42862 7.49992C6.42862 7.13173 6.1408 6.83325 5.78576 6.83325C5.43072 6.83325 5.14291 7.13173 5.14291 7.49992V15.8332C5.14291 16.2014 5.43072 16.4999 5.78576 16.4999C6.1408 16.4999 6.42862 16.2014 6.42862 15.8332V7.49992ZM9.00004 6.83325C9.35508 6.83325 9.64289 7.13173 9.64289 7.49992V15.8332C9.64289 16.2014 9.35508 16.4999 9.00004 16.4999C8.645 16.4999 8.35718 16.2014 8.35718 15.8332V7.49992C8.35718 7.13173 8.645 6.83325 9.00004 6.83325ZM12.8572 7.49992C12.8572 7.13173 12.5693 6.83325 12.2143 6.83325C11.8593 6.83325 11.5715 7.13173 11.5715 7.49992V15.8332C11.5715 16.2014 11.8593 16.4999 12.2143 16.4999C12.5693 16.4999 12.8572 16.2014 12.8572 15.8332V7.49992Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e4494317.svg";
export { ForwardRef as ReactComponent };